import { lazy } from "react"

export const AuthorizationError = lazy(() => import("./AuthorizationError"))
